// @flow

import React, { Fragment } from 'react';
import { GridSquare, GridSquareItem } from '@riseart/grid';
import { CreateRsvpProvider } from 'shared_data/providers/rsvp/CreateRsvp';
import { EventCard } from 'shared_components/event/Card';

type Props = {
  items: Array<Object>,
  lazyloadConfig: Object,
};

/**
 * ArtistEventList
 *
 * @param {Props} props
 */
export const ArtistEventList = ({ items, lazyloadConfig }: Props) => {
  const totalItems = (items && items.length) || 0;
  const artDirectionSizeKey =
    (totalItems === 1 && 'artist.eventCol1') ||
    (totalItems === 2 && 'artist.eventCol2') ||
    'artist.eventCol3';

  if (totalItems === 1) {
    return (
      <Fragment>
        <CreateRsvpProvider eventsList={items} />
        <EventCard
          event={items[0]}
          layout="horizontal"
          size="large"
          lazyloadConfig={lazyloadConfig}
          artDirectionSizeKey={artDirectionSizeKey}
        />
      </Fragment>
    );
  }

  if (totalItems > 1) {
    return (
      <Fragment>
        <CreateRsvpProvider eventsList={items} />
        <GridSquare columnCount={totalItems} justify="space-between">
          {items.map((event) => (
            <GridSquareItem key={event.id} columnCount={totalItems}>
              <EventCard
                event={event}
                lazyloadConfig={lazyloadConfig}
                artDirectionSizeKey={artDirectionSizeKey}
              />
            </GridSquareItem>
          ))}
        </GridSquare>
      </Fragment>
    );
  }

  return null;
};
